module.exports = __webpack_public_path__ + "media/bootstrap-icons/phone-landscape-fill-08d3cda7.svg";